import Deploy from './Deploy';

export default Deploy;
